$(function(){
    $('[data-toggle="tooltip"]').tooltip({container: 'body'});

    var elems = Array.prototype.slice.call(document.querySelectorAll('.js-switch-tv'));
    elems.forEach(function(html) {
        var switchery = new Switchery(html,{ size: 'small' });
    });

    if($("#filter_count_tv").length){
        var fc = $("#filter_count_tv").val();
        if(fc > 0){
            $("#filter_count_leagues").html(fc);
            $("#filter_count_leagues").show();
        }
    }
    if($("#filter_count_channels").length){
        var fc = $("#filter_count_channels").val();
        if(fc > 0){
            $("#filter_count_tvchannels").html(fc);
            $("#filter_count_tvchannels").show();
        }
    }

    $(".btn-tv-filter").click(function(){
        if(!$(this).hasClass("btn-tv-filter-active")) {
            $(".btn-tv-filter").not($(this)).removeClass("btn-tv-filter-active");
            $(this).addClass("btn-tv-filter-active");
            $("#tv_tableau").css("opacity", "0.2");

            var league_id = $(this).data("league-id");

            $.get(
                ajaxUrl+"/ajax/filterTvTableau.php",
                {
                    league_id : league_id
                },
                function(data){
                    var result = $.parseJSON(data);
                    if(result.success == true){
                        $("#tv_tableau").html(result.data);
                        $("#tv_tableau").css("opacity", "1");
                        /*$('img[data-src]').each(function(img){
                            $(this).attr('src', $(this).data('src'));
                            $(this).removeAttr('data-src');
                        });*/
                    }
                }
            );

        } else {
            $("#tv_tableau").css("opacity", "0.2");
            $.get(
                ajaxUrl+"/ajax/filterTvTableau.php",
                {
                    league_id : "all"
                },
                function(data){
                    var result = $.parseJSON(data);
                    if(result.success == true){
                        $("#tv_tableau").html(result.data);
                        $("#tv_tableau").css("opacity", "1");
                        /*$('img[data-src]').each(function(img){
                            $(this).attr('src', $(this).data('src'));
                            $(this).removeAttr('data-src');
                        });*/
                    }
                }
            );

            $(this).removeClass("btn-tv-filter-active");
        }
    });

    $(".filter_switch_tv").change(function(){
        $("#tv_tableau").css("opacity", "0.2");
        var filtered_leagues = "";
        var filter_count = 0;
        $(".filter_switch_tv").each(function(){
            if($(this).is(":checked")){
                filtered_leagues += $(this).data("league-id") + ",";
                filter_count++;
            }
        });

        if(filtered_leagues == ""){
            filtered_leagues = "all";
        }

        if(filter_count > 0){
            $("#filter_count_leagues").html(filter_count);
            $("#filter_count_leagues").show();
        } else {
            $("#filter_count_leagues").html(0);
            $("#filter_count_leagues").hide();
        }

        Cookies.set('filtered_leagues_tv', filtered_leagues, { expires: 0.01, path: '/' });

        var filtered_channels = Cookies.get("filtered_tv_channels");
        if(filtered_channels == "" || filtered_channels == undefined){
            filtered_channels = "all";
        }

        var incl_bookmakers = $("#tv_incl_bookmakers").val();

        $.get(
            ajaxUrl+"/ajax/filterTvTableau.php",
            {
                leagues : filtered_leagues,
                channels : filtered_channels,
                include_bookmaker_streams : incl_bookmakers
            },
            function(data){
                var result = $.parseJSON(data);
                if(result.success == true){
                    $("#tv_tableau").html(result.data);
                    $("#tv_tableau").css("opacity", "1");
                    /*$('img[data-src]').each(function(img){
                        $(this).attr('src', $(this).data('src'));
                        $(this).removeAttr('data-src');
                    });*/
                    if(filtered_leagues != "all"){
                        $(".tv-filter-box .svg-inline--fa").addClass("filter-active");
                    }
                }
            }
        );
    });

    $(".filter_switch_tv_channel").change(function(){
        $("#tv_tableau").css("opacity", "0.2");
        var filtered_channels = "";
        var filter_count = 0;
        $(".filter_switch_tv_channel").each(function(){
            if($(this).is(":checked")){
                filtered_channels += $(this).data("channel-id") + ",";
                filter_count++;
            }
        });

        if(filtered_channels == ""){
            filtered_channels = "all";
        }

        if(filter_count > 0){
            $("#filter_count_tvchannels").html(filter_count);
            $("#filter_count_tvchannels").show();
        } else {
            $("#filter_count_tvchannels").html(0);
            $("#filter_count_tvchannels").hide();
        }

        Cookies.set('filtered_tv_channels', filtered_channels, { expires: 0.01, path: '/' });

        var filtered_leagues = Cookies.get("filtered_leagues_tv");
        if(filtered_leagues == "" || filtered_leagues == undefined){
            filtered_leagues = "all";
        }

        //var incl_bookmakers = $("#tv_incl_bookmakers").val();

        $.get(
            ajaxUrl+"/ajax/filterTvTableau.php",
            {
                leagues : filtered_leagues,
                channels : filtered_channels,
                //include_bookmaker_streams : incl_bookmakers
            },
            function(data){
                var result = $.parseJSON(data);
                if(result.success == true){
                    $("#tv_tableau").html(result.data);
                    $("#tv_tableau").css("opacity", "1");
                    /*$('img[data-src]').each(function(img){
                        $(this).attr('src', $(this).data('src'));
                        $(this).removeAttr('data-src');
                    });*/
                    if(filtered_leagues != "all"){
                        $(".tv-filter-box .svg-inline--fa").addClass("filter-active");
                    }
                }
            }
        );
    });

    $(".tv_incl_bookmakers").click(function(){
        $(".betstream-expl").slideToggle("FAST");
        /*if($("#tv_incl_bookmakers").val() == 0){
            $("#tv_incl_bookmakers").val(1);
            $(this).find(".svg-inline--fa").attr("data-icon", "check-square");
        } else {
            $("#tv_incl_bookmakers").val(0);
            $(this).find(".svg-inline--fa").attr("data-icon", "square");
        }

        $("#tv_tableau").css("opacity", "0.2");
        var include_bookmaker_streams = $("#tv_incl_bookmakers").val();
        if($("#tv_incl_bookmakers").val() == 1){
            Cookies.set('tv_incl_bookmakers', 1, { expires: 0.01, path: '/' });
            include_bookmaker_streams = 1;
        } else {
            Cookies.set('tv_incl_bookmakers', 0, { expires: 0.01, path: '/' });
            include_bookmaker_streams = 0;
        }

        var filtered_leagues = Cookies.get('filtered_leagues_tv');
        if(filtered_leagues == "" || filtered_leagues == undefined){
            filtered_leagues = "all";
        }

        var filtered_channels = Cookies.get("filtered_tv_channels");
        if(filtered_channels == "" || filtered_channels == undefined){
            filtered_channels = "all";
        }

        $.post(
            ajaxUrl+"/ajax/filterTvTableau.php",
            {
                leagues : filtered_leagues,
                channels : filtered_channels,
                include_bookmaker_streams : include_bookmaker_streams
            },
            function(data){
                var result = $.parseJSON(data);
                if(result.success == true){
                    $("#tv_tableau").html(result.data);
                    $("#tv_tableau").css("opacity", "1");
                    $('img[data-src]').each(function(img){
                        $(this).attr('src', $(this).data('src'));
                        $(this).removeAttr('data-src');
                    });
                }
            }
        );*/

        return false;
    });

    $(document).on("click", ".tv-filter-bm", function(){
        if($(this).data("set") == 0){
            $.get(
                ajaxUrl+"/ajax/filterTvTableau.php",
                {
                    leagues : "all",
                    channels : "520,",
                },
                function(data){
                    var result = $.parseJSON(data);
                    if(result.success == true){
                        $("#tv_tableau").html(result.data);
                        $("#tv_tableau").css("opacity", "1");
                        $('img[data-src]').each(function(img){
                            $(this).attr('src', $(this).data('src'));
                            $(this).removeAttr('data-src');
                        });
                    }
                }
            );
            $(this).data("set", 1);
            $(this).addClass("tv-bm-set");
        } else {
            $.get(
                ajaxUrl+"/ajax/filterTvTableau.php",
                {
                    leagues : "all",
                    channels : "all",
                },
                function(data){
                    var result = $.parseJSON(data);
                    if(result.success == true){
                        $("#tv_tableau").html(result.data);
                        $("#tv_tableau").css("opacity", "1");
                        $('img[data-src]').each(function(img){
                            $(this).attr('src', $(this).data('src'));
                            $(this).removeAttr('data-src');
                        });
                    }
                }
            );
            $(this).data("set", 0);
            $(this).removeClass("tv-bm-set");
        }
        return;
    });

    $(".filter_switch_tv_spelbolag").change(function(){
        $("#tv_tableau").css("opacity", "0.2");
        var exclude_bookmaker_streams = 0;
        if($(this).is(":checked")){
            Cookies.set('tv_excl_bookmakers', 0, { expires: 0.01, path: '/' });
            exclude_bookmaker_streams = 0;
        } else {
            Cookies.set('tv_excl_bookmakers', 1, { expires: 0.01, path: '/' });
            exclude_bookmaker_streams = 1;
        }

        var filtered_leagues = Cookies.get('filtered_leagues_tv');
        if(filtered_leagues == "" || filtered_leagues == undefined){
            filtered_leagues = "all";
        }

        $.get(
            ajaxUrl+"/ajax/filterTvTableau.php",
            {
                leagues : filtered_leagues,
                include_bookmaker_streams : exclude_bookmaker_streams
            },
            function(data){
                var result = $.parseJSON(data);
                if(result.success == true){
                    $("#tv_tableau").html(result.data);
                    $("#tv_tableau").css("opacity", "1");
                    /*$('img[data-src]').each(function(img){
                        $(this).attr('src', $(this).data('src'));
                        $(this).removeAttr('data-src');
                    });*/
                }
            }
        );

    });
});